import { render, staticRenderFns } from "./PaymentInvoicePage.vue?vue&type=template&id=2132843c&scoped=true&"
import script from "./PaymentInvoicePage.vue?vue&type=script&lang=ts&"
export * from "./PaymentInvoicePage.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentInvoicePage.vue?vue&type=style&index=0&id=2132843c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2132843c",
  null
  
)

export default component.exports